import { ChartLineIcon } from "@phosphor-icons/react";

import type { CarouselSlide } from "@alpacahq/ui/old";

export interface OptionsSlideProps {
  onApply: () => void;
}

export const optionsSlide = ({
  onApply,
}: OptionsSlideProps): CarouselSlide => ({
  id: "options",
  title: (
    <h2 className="m-0 font-semibold text-gray-800">
      Trade Options Commission Free
    </h2>
  ),
  description: (
    <span className="text-gray-700 text-sm">
      Build strategies like{" "}
      <a
        href="https://alpaca.markets/learn/long-straddle?utm_source=dashboard&utm_medium=banner&utm_campaign=options_closeable_banner"
        target="_blank"
        rel="noopener noreferrer"
        className="text-indigo-500 underline"
      >
        straddles
      </a>
      ,{" "}
      <a
        href="https://alpaca.markets/learn/iron-butterfly?utm_source=dashboard&utm_medium=banner&utm_campaign=options_closeable_banner"
        target="_blank"
        rel="noopener noreferrer"
        className="text-indigo-500 underline"
      >
        butterflies
      </a>
      , and{" "}
      <a
        href="https://alpaca.markets/learn/calendar-spread?utm_source=dashboard&utm_medium=banner&utm_campaign=options_closeable_banner"
        target="_blank"
        rel="noopener noreferrer"
        className="text-indigo-500 underline"
      >
        spreads
      </a>{" "}
      with our Trading API and Dashboard. Read our{" "}
      <a
        href="https://alpaca.markets/learn/how-to-trade-options-with-alpaca?utm_source=dashboard&utm_medium=banner&utm_campaign=options_closeable_banner"
        target="_blank"
        rel="noopener noreferrer"
        className="text-indigo-500 underline"
      >
        options trading guide
      </a>{" "}
      to get started.
    </span>
  ),
  icon: <ChartLineIcon size={24} />,
  openInNewTab: true,
  button: {
    label: "Apply Now",
    onClick: onApply,
  },
});
